import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
import(/* webpackMode: "eager" */ "/build/src/app/common-error-alert.tsx");
import(/* webpackMode: "eager" */ "/build/src/app/i18n/client.ts");
import(/* webpackMode: "eager" */ "/build/src/app/search/structure/structure-search.tsx");
import(/* webpackMode: "eager" */ "/build/src/context/language.ts")